// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Region from "common/src/Region.bs.js";
import * as LbUtils from "./LbUtils.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Select from "@mui/material/Select";

function LbRegionSelect(Props) {
  var region = Props.region;
  var setRegion = Props.setRegion;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "hidden md:block"
                }, React.createElement(Tabs, {
                      children: Belt_Array.map(LbUtils.allRegions, (function (r) {
                              return React.createElement(Tab, {
                                          label: r === "global" ? "All" : Region.toName3(Region.fromApiName(r)),
                                          value: r,
                                          classes: {
                                            root: LbUtils.Styles.tab
                                          },
                                          key: r
                                        });
                            })),
                      value: Belt_Option.mapWithDefault(region, "global", Region.toApiName),
                      onChange: (function (param, v) {
                          return Curry._1(setRegion, Region.fromApiNameSafe(v));
                        })
                    })), React.createElement("div", {
                  className: "md:hidden"
                }, React.createElement(Select, {
                      native: true,
                      value: Belt_Option.mapWithDefault(region, "global", Region.toApiName),
                      onChange: (function (e) {
                          var v = e.target.value;
                          return Curry._1(setRegion, Region.fromApiNameSafe(v));
                        }),
                      variant: "standard",
                      children: Belt_Array.map(LbUtils.allRegions, (function (region) {
                              return React.createElement("option", {
                                          key: region,
                                          value: region
                                        }, region === "global" ? "All" : Region.toName3(Region.fromApiName(region)));
                            }))
                    })));
}

var make = LbRegionSelect;

export {
  make ,
  
}
/* react Not a pure module */
